module.exports = __webpack_public_path__ + "static/media/Instagram-black.44ef48f0.svg";